<template>
  <div>

    <!-- 1st -->
    <section class="section">
      <div class="container px-0">
        <div class="row justify-content-center text-center">
          <div class="col-lg-8">
            <h2 class="display-3 mb-md text-primary mt-5">HYBRID CHB FOR FENCE</h2>
          </div>
        </div>
        <div class="row row-grid">
          <div class="col-md-6">
            <div class="card border-0">
              <img v-lazy="'img/products/hybrid/easyhomes-panel-hybrid-chb.png'" class="card-img-top" height="400" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="pl-md-2">
              <p>
                <span class="heading ml-3">UNIQUE FEATURES</span>
              <ul>
                <li>2000PSI (much stronger than ordinary CHB)</li>
                <li>Pre-casted</li>
                <li>Can retain soil up to 1m elevation</li>
                <li>Smooth finish</li>
                <li>Easy to install (3x faster than ordinary CHB)</li>
                <li>Can withstand windload up to 150.343 mph to 250 kph</li>
              </ul>
              </p>
              <p class="mt-5">
                <span class="heading ml-3">PANEL DIMENSION</span>
              <ul>
                <li>2500mm length</li>
                <li>100mm thickness</li>
                <li>350mm height</li>
              </ul>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 2nd -->
    <section class="section background mb-md">
      <div class="container px-0">
        <div class="row justify-content-center text-center">
          <div class="col-lg-8">
            <h2 class="display-3 mb-md text-primary">HYBRID CHB FOR HOUSING</h2>
          </div>
        </div>
        <div class="row row-grid">
          <div class="col-md-12">
            <div class="card bg-default shadow border-0">
              <img v-lazy="'img/products/hybrid/easyhomes-hybrid-chb-for-housing.jpg'"
                class="card-img-top shadow-lg rounded" />
            </div>
          </div>
        </div>
        <div class="row row-grid">
          <div class="col-md-6">
            <div class="pl-md-2">
              <p>
                <span class="heading ml-3">UNIQUE FEATURES</span>
              <ul>
                <li>2000PSI (much stronger than ordinary CHB) </li>
                <li>Contributes to sound reduction </li>
                <li>Contributes to thermal insulation </li>
                <li>Easy to install (3x faster than ordinary CHB)</li>
              </ul>
              </p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="pl-md-2">
              <p>
                <span class="heading ml-3">PANEL DIMENSION</span>
              <ul>
                <li>2090mm x 350mm x 100mm </li>
                <li>1865mm x 350mm x 100mm </li>
                <li>1375mm x 350mm x 100mm </li>
                <li>1110mm x 350mm x 100mm </li>
                <li>885mm x 350mm x 100mm </li>
                <li>620mm x 350mm x 100mm </li>
                <li>395mm x 350mm x 100mm</li>
              </ul>
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 pt-5">
            <b-carousel controls indicators>
              <b-carousel-slide>
                <template v-slot:img>
                  <b-card-group>
                    <b-card no-body class="card-img-top" img-src="img/products/hybrid/carousel/7-housing-hybrid-chb.png"
                      style="border: none;"></b-card>
                    <b-card no-body class="card-img-top" img-src="img/products/hybrid/carousel/6-housing-hybrid-chb.png"
                      style="border: none;"></b-card>
                    <b-card no-body class="card-img-top" img-src="img/products/hybrid/carousel/5-housing-hybrid-chb.png"
                      style="border: none;"></b-card>
                    <b-card no-body class="card-img-top" img-src="img/products/hybrid/carousel/4-housing-hybrid-chb.png"
                      style="border: none;"></b-card>
                  </b-card-group>
                </template>
              </b-carousel-slide>
              <b-carousel-slide>
                <template v-slot:img>
                  <b-card-group>
                    <b-card no-body class="card-img-top" img-src="img/products/hybrid/carousel/3-housing-hybrid-chb.png"
                      style="border: none;"></b-card>
                    <b-card no-body class="card-img-top" img-src="img/products/hybrid/carousel/2-housing-hybrid-chb.png"
                      style="border: none;"></b-card>
                    <b-card no-body class="card-img-top" img-src="img/products/hybrid/carousel/1-housing-hybrid-chb.png"
                      style="border: none;"></b-card>
                    <b-card no-body class="card-img-top" style="border: none;"></b-card>
                  </b-card-group>
                </template>
              </b-carousel-slide>
            </b-carousel>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { BCarousel } from "bootstrap-vue/esm/components/carousel/carousel";
import { BCarouselSlide } from "bootstrap-vue/esm/components/carousel/carousel-slide";
import { BCardGroup } from "bootstrap-vue/esm/components/card/card-group";
import { BCard } from "bootstrap-vue/esm/components/card/card";

export default {
  name: "hybrid-chb",
  components: {
    BCarousel,
    BCarouselSlide,
    BCardGroup,
    BCard,
  },
};
</script>

<style scoped>
.heading{
  font-weight: bold;
}

.text-primary{
  font-weight: bold !important;
}
</style>